import { ReactNode } from 'react';

import classNames from 'classnames';

type Props = {
  description: string;
  value: ReactNode;
  isStrong?: boolean;
};

export const PriceDetailItem = ({ description, value, isStrong }: Props) => {
  return (
    <div className="flex items-center gap-2 ">
      <span
        className={classNames(
          'whitespace-nowrap',
          isStrong
            ? 'text-base-text-primary text-caption-sm-strong-d'
            : 'text-base-text-tertiary text-caption-sm-d',
        )}
      >
        {description}
      </span>
      <div className="flex-grow border border-dashed self-end mb-1.5  text-base-text-quaternary" />
      <span className="whitespace-nowrap text-base-text-primary text-caption-sm-strong-d">
        {value}
      </span>
    </div>
  );
};
